import { createSelector } from 'reselect';
import { find, isEmpty, filter, flow, negate } from 'lodash/fp';

// State Selectors

const $sections = editor => editor.sections;
const $currentSection = editor => editor.currentSection;
const $sectionId = (editor, id) => id;
const $elementId = (editor, id) => id;

// Section Selectors

export const isCurrentSection = () =>
  createSelector(
    [$currentSection, $sectionId],
    (current, id) => current.id === id,
  );

export const getSection = createSelector(
  [$sections, $sectionId],
  (sections, id) => find({ id }, sections),
);

export const getElement = createSelector(
  [$currentSection, $sectionId],
  ({ elements }, id) => find({ id }, elements),
);

export const isLessonEmpty = createSelector(
  [$currentSection],
  ({ elements }) => !elements && isEmpty(elements),
);

export const getChildElements = () =>
  createSelector([$currentSection, $elementId], ({ elements }, parentId) =>
    filter({ parent_id: parentId }, elements),
  );

export const hasChildren = createSelector(
  [$currentSection, $elementId],
  ({ elements }, parentId) =>
    flow(filter({ parent_id: parentId }), negate(isEmpty))(elements),
);
